import { getSessionStorage, setSessionStorage, StorageKey } from '@utils/StorageUtils';
import { Country, PageName } from '@utils/pageConfig/Types';
import { Action, RetailerClientTypes } from '@state/actions/Type';

export interface RetailerClientState {
  clientId: number;
  countries: Country[];
  clientName?: string;
  pageViewing?: PageName;
}

const getInitialState = () => {
  const storeRetailerClient = JSON.parse(getSessionStorage(StorageKey.RetailerClient) as string);

  if (storeRetailerClient !== null) {
    return {
      clientId: storeRetailerClient.clientId,
      countries: storeRetailerClient.countries,
    };
  }

  return Object.freeze({
    clientId: -1, // -1 for default clientId
    countries: [
      {
        id: '',
        name: '',
        currency: '',
        currencyLabel: '',
      },
    ],
  });
};

const RetailerClientReducer = (
  state: RetailerClientState = getInitialState(), // NOSONAR typescript:S1788
  action: Action,
) => {
  if (action.type === RetailerClientTypes.RetailerClientUpdate) {
    const finalPayLoad = {
      ...state,
      ...action.payload,
    };
    setSessionStorage(StorageKey.RetailerClient, JSON.stringify(finalPayLoad));
    return finalPayLoad;
  }
  return state;
};

export default RetailerClientReducer;
